import { InputLabel, MenuItem, Select } from "@mui/material";
import React from "react";
import { useEffect, useState } from "react";
import { IListClientsResponse } from "../../model/base/response/list-clients-response";
import ApplicationAppService from "../../application/platform/application-app-service";
import AuthenticatorAppService from "../../application/platform/security/authenticator-app-service";


export interface DefaultSelectClientProps {
    handleOnChange?: (e: any) => void;
    clientId?: number | undefined;
    required: boolean;
    disabled?: boolean;
}

export default function DefaultSelectClient(props: DefaultSelectClientProps) {
    const applicationData = ApplicationAppService.getAuthenticationData();
    const [clients, setClients] = useState<IListClientsResponse[]>([]);
    const [internalClientId, setInternalClientId] = useState<string>(applicationData?.type === 1 ? applicationData.company.id.toString() : "");


    const handleOnChange = (e: any) => {
        if (props.handleOnChange != undefined) {
            props.handleOnChange(e);
        }
        setInternalClientId(e.target.value);
    }

    useEffect(() => {

        (async () => {

            if (props.clientId !== undefined && props.clientId.toString() !== internalClientId) {
                const data = await AuthenticatorAppService.listClients(props.clientId);
                setClients(data);
                setInternalClientId(props.clientId.toString());
                handleOnChange({ target: { name: "select-client", value: internalClientId } });
            }
       
            

        })();


    }, [props.clientId]);



    useEffect(() => {
        (async () => {
            const data = await AuthenticatorAppService.listClients(undefined);
            setClients(data);
            handleOnChange({ target: { name: "select-client", value: internalClientId } });
        })();
    }, []);




    return (
        <React.Fragment>
            <InputLabel>Entidade</InputLabel>
            <Select
                name='select-client'
                onChange={handleOnChange}
                fullWidth
                size="small"
                disabled={props.disabled !== undefined ? props.disabled : false}
                error={props.required && (internalClientId === undefined || internalClientId.length === 0) ? true : false}
                defaultValue={""}
                value={internalClientId?.toString()}
            >

                {clients.length > 1 && (
                    <MenuItem value={undefined}>
                        <em>Selecionar</em>
                    </MenuItem>)}
                {clients.map((element, index) => {
                    return (
                        <MenuItem value={element.id.toString()} key={element.id}>{element.name} - {element.formattedDocument}</MenuItem>
                    );
                })}
            </Select>
        </React.Fragment>
    );
}
